<template>
  <section class="section">
    <div class="container">
      <h1 class="title">
        Аутомати
      </h1>
      <img src="@/assets/images/automati1.jpg" alt="" />

      <h1 class="title">
        Мапа аутомата
      </h1>
      <img src="@/assets/images/automati2.jpg" alt="" />
    </div>
    <Footer />
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
export default {
  components: {
    Footer
  }
}
</script>

<style></style>
